"use client";

import { c as _c } from "react/compiler-runtime";
import { IconFilter } from "@tabler/icons-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { PlpDrawerFilterActions } from "./PlpDrawerFilterActions";
import { type PlpFilterScope, PlpFilterSidebar } from "./PlpFilterSidebar";
interface Props extends PlpFilterScope {
  activeCount?: number;
}
export function PlpFilterDrawerButton(t0) {
  const $ = _c(16);
  const {
    activeCount: t1,
    excludeAttributes,
    bakedAttributes
  } = t0;
  const activeCount = t1 === undefined ? 0 : t1;
  const [open, setOpen] = useState(false);
  const label = activeCount > 0 ? `Filter (${activeCount})` : "Filter";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconFilter className="size-4" aria-hidden={true} />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label) {
    t4 = <Button type="button" variant="outline" onClick={t2} className="gap-2" data-testid="plp-filter-drawer-button">{t3}{label}</Button>;
    $[2] = label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SheetTitle>Filters</SheetTitle>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center justify-between">{t5}<PlpDrawerFilterActions onClose={() => setOpen(false)} /></div>;
    t7 = <SheetDescription className="sr-only">Refine the product list with filters.</SheetDescription>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== bakedAttributes || $[8] !== excludeAttributes) {
    t8 = <SheetContent side="left" showCloseButton={false} data-testid="plp-filter-drawer-content" className="w-full max-w-sm overflow-y-auto p-6">{t6}{t7}<div className="pt-4"><PlpFilterSidebar excludeAttributes={excludeAttributes} bakedAttributes={bakedAttributes} /></div></SheetContent>;
    $[7] = bakedAttributes;
    $[8] = excludeAttributes;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== open || $[11] !== t8) {
    t9 = <Sheet open={open} onOpenChange={setOpen}>{t8}</Sheet>;
    $[10] = open;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t4 || $[14] !== t9) {
    t10 = <div className="lg:hidden" data-testid="plp-filter-drawer-button-root">{t4}{t9}</div>;
    $[13] = t4;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}